import styles from '../../styles/admin/SignIn.module.scss'

interface SignInLayoutProps {
  children: React.ReactNode
}

const SignInLayout = ({ children }: SignInLayoutProps) => {
  return (
    <div className={styles.container}>
      {/* 우주+지구 배경 */}
      <img
        src="/assets/login/login-bg-wide.png"
        alt="Background"
        className={styles.bgImage}
      />

      {/* 반짝이는 별 */}
      <img
        src="/assets/login/background-2.svg"
        alt=""
        className={`${styles.star} ${styles.star1}`}
      />
      <img
        src="/assets/login/background-3.svg"
        alt=""
        className={`${styles.star} ${styles.star2}`}
      />
      <img
        src="/assets/login/background-3.svg"
        alt=""
        className={`${styles.star} ${styles.star3}`}
      />

      {/* 별똥별 */}
      <div className={`${styles.shooter} ${styles.shooter1}`} />
      <div className={`${styles.shooter} ${styles.shooter2}`} />
      <div className={`${styles.shooter} ${styles.shooter3}`} />

      {children}
    </div>
  )
}

export default SignInLayout
